module.exports = __webpack_public_path__ + "img/s-sizing-chart.ed423464.webp";